import { configure } from 'mobx';

// `enforceActions: 'never'` disables the warnings that MobX otherwise emits
// when an observed observable is mutated outside an action. The default
// ('observed') is hostile to async/await: `action(asyncFn)` only wraps the
// synchronous prelude before the first `await`; post-await mutations land
// in a fresh microtask and warn. The alternatives (sprinkling
// `runInAction`, switching to generator-based `flow`) bloat or contort
// async code for no real benefit in this codebase — our mutations are
// almost all single-observable writes, which are each already their own
// transaction with no batching to preserve. The exception is a synchronous
// *bulk* write (an entity's `_init`/`reinitialize`, an aggregate reorder):
// that still wraps itself in an explicit `action(...)` so the whole rebuild
// batches into one transaction rather than firing a reaction per `.set()`.
//
// Side-effect import; importers don't read any export. Both `src/index.tsx`
// (production entry) and the vitest setup file import this so app and tests
// run under identical MobX configuration.
configure({ enforceActions: 'never' });
